<template>
  <div class="fixed bottom-0 left-0 right-0 z-999">
    <div
      class="center flex items-stretch tc shadow-5 br2 br--top overflow-hidden"
      :class="{
        'bg-purple': brand === 'lh',
        'bg-yellow': brand === 'lq',
      }"
      style="max-width: 72rem"
    >
      <router-link
        :to="'/developments/' + $route.params.id"
        class="link w-25 pv4 f6 f5-l fw6 tracked lh-solid nowrap bg-animate br b--black-10"
        :class="{
          'white': brand === 'lh',
          'dark-gray': brand === 'lq',
          'bg-black-20': brand === 'lh' && $route.name === 'development',
          'bg-dark-gray white': brand === 'lq' && $route.name === 'development'
        }"
      >
        SITE PLAN
      </router-link>
      <router-link
        :to="'/developments/' + $route.params.id + '/local-information'"
        class="link w-25 pv4 f6 f5-l fw6 tracked lh-solid nowrap bg-animate br b--black-10"
        :class="{
          'white': brand === 'lh',
          'dark-gray': brand === 'lq',
          'bg-black-20': brand === 'lh' && $route.name === 'local-information',
          'bg-dark-gray white': brand === 'lq' && $route.name === 'local-information'
        }"
      >
        LOCAL INFORMATION
      </router-link>
      <router-link
        :to="'/developments/' + $route.params.id + '/about/company'"
        class="link w-25 pv4 f6 f5-l fw6 tracked lh-solid nowrap bg-animate br b--black-10"
        :class="{
          'white': brand === 'lh',
          'dark-gray': brand === 'lq',
          'bg-black-20': brand === 'lh' && $route.name.startsWith('about'),
          'bg-dark-gray white': brand === 'lq' && $route.name.startsWith('about')
        }"
      >
        ABOUT
      </router-link>
      <router-link
        :to="{name: 'developments', params: { focusId: $route.params.id } }"
        class="link w-25 pv4 f6 f5-l fw6 tracked lh-solid nowrap bg-animate"
        :class="{
          'white': brand === 'lh',
          'dark-gray': brand === 'lq',
          'bg-black-20': brand === 'lh' && $route.path === '/',
          'bg-dark-gray white': brand === 'lq' && $route.path === '/'
        }"
      >
        DEVELOPMENTS
      </router-link>
    </div>
  </div>
</template>
<script>
export default {
  name: 'NavPrimary',
  computed: {
    brand () {
      if (this.$store.state.content && this.$route.params.id) {
        return this.$store.getters.getDevelopment('developments/' + this.$route.params.id).brand
      } else {
        return 'lh'
      }
    }
  }
}
</script>
